/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { SalesStrictHttpResponse } from '../../sales-strict-http-response';
import { SalesRequestBuilder } from '../../sales-request-builder';

import { SalesContractPaymentResponseDto } from '../../models/sales-contract-payment-response-dto';

export interface ContractPaymentsControllerFindAllByTenant$Params {

/**
 * Tenant ID
 */
  tenant: string;

/**
 * Optional contract ID to filter contract payments
 */
  contractId?: string;

/**
 * Optional Project Manager id filter. When set, only payments whose denormalised PM matches are returned.
 */
  projectManagerId?: string;
}

export function contractPaymentsControllerFindAllByTenant(http: HttpClient, rootUrl: string, params: ContractPaymentsControllerFindAllByTenant$Params, context?: HttpContext): Observable<SalesStrictHttpResponse<Array<SalesContractPaymentResponseDto>>> {
  const rb = new SalesRequestBuilder(rootUrl, contractPaymentsControllerFindAllByTenant.PATH, 'get');
  if (params) {
    rb.path('tenant', params.tenant, {});
    rb.query('contractId', params.contractId, {});
    rb.query('projectManagerId', params.projectManagerId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as SalesStrictHttpResponse<Array<SalesContractPaymentResponseDto>>;
    })
  );
}

contractPaymentsControllerFindAllByTenant.PATH = '/o2-sales/contract-payments/{tenant}';
